// extracted by mini-css-extract-plugin
module.exports = {"companyOverview":"companyOverview-2o87td7OU8Rrd8Roue7Pv_","header":"header-190Clw2_Dq_dT62LMDt5yk","star":"star-35A4yqvRQa0RU5NfP-8T0D","title":"title-AbNshW0Iw7Y_uvEuP_Yqr"};